import { professionalTranslationFor } from '../data/professionalTranslationRuntime.js';

const STAGE_LABELS = Object.freeze({
  en: 'Stage',
  ar: 'المرحلة',
  bn: 'ধাপ',
  zh: '阶段',
  fa: 'مرحله',
  fr: 'Étape',
  gu: 'તબક્કો',
  it: 'Fase',
  pl: 'Etap',
  pt: 'Etapa',
  pa: 'ਪੜਾਅ',
  ro: 'Etapa',
  so: 'Marxalad',
  es: 'Etapa',
  tl: 'Yugto',
  tr: 'Aşama',
  ur: 'مرحلہ',
});

export function journeyStageLabel(language, index) {
  const normalizedLanguage = String(language || 'en').toLowerCase().split('-')[0];
  const label = professionalTranslationFor(normalizedLanguage, 'journeyStageUi', 'stage') || STAGE_LABELS[normalizedLanguage] || STAGE_LABELS.en;
  return `${label} ${index}`;
}

export { STAGE_LABELS };
